import { Box } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';

export const TableWithHeading = ({ heading, children, boxProps }) => {
  return <Box {...boxProps} mt="1.25rem">
    <Text fontSize="1.313rem" fontWeight="bold">{heading}</Text>
    {children}
  </Box>;
};